export default {
      id: "edifycalendar-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#edifycalendar",
      toString: function () {
        return this.url;
      }
    }